import { getApiBaseURL } from "../api/client";

const STORAGE_KEY = "selectedBrandForLayoutForm.v1";

/** Must match `LAYOUT_FORM_BRAND_KEY` in public/stillinputform.html and public/videoInput.html */
export const LAYOUT_FORM_BRAND_KEY = "layoutFormBrandContext";

/**
 * Save selected brand payload before navigating to static HTML layout form.
 * Uses localStorage so browser refresh still keeps context.
 */
export function saveSelectedBrandForLayoutForm(payload) {
  if (!payload || typeof payload !== "object") return;
  const enriched = {
    ...payload,
    savedAt: new Date().toISOString(),
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(enriched));
}

export function loadSelectedBrandForLayoutForm() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearSelectedBrandForLayoutForm() {
  localStorage.removeItem(STORAGE_KEY);
}

export const layoutFormStorageKey = STORAGE_KEY;

/** @param {object} b — row from GET /api/brands */
export function listItemToBrandPayload(b) {
  return {
    id: b.id,
    brandName: b.brandName || "",
    clientName: b.clientName || "",
    logoUrl: b.logoUrl || "",
    registrationId: b.registrationId || "",
    website: b.website || "",
    email: b.emailId || "",
    contactNumber: b.phoneNumber || "",
    contactPerson: b.contactName || "",
    address: b.address || "",
    city: b.city || "",
    zipCode: b.zipCode || "",
  };
}

function absoluteLogoUrl(rawLogo) {
  if (!rawLogo || /^(https?:)?\/\//i.test(rawLogo) || rawLogo.startsWith("data:")) {
    return rawLogo || "";
  }
  const base = (getApiBaseURL() || "").replace(/\/$/, "");
  return base ? `${base}${rawLogo.startsWith("/") ? "" : "/"}${rawLogo}` : rawLogo;
}

/**
 * @param {object} brandListItem
 * @param {'still'|'video'} postType
 */
export function openLayoutInputFormForBrand(brandListItem, postType = "still") {
  const payload = listItemToBrandPayload(brandListItem);
  saveSelectedBrandForLayoutForm(payload);

  try {
    sessionStorage.setItem(
      LAYOUT_FORM_BRAND_KEY,
      JSON.stringify({
        version: 1,
        source: "dashboard",
        id: payload.id,
        name: payload.brandName || "",
        logoUrl: absoluteLogoUrl(payload.logoUrl),
        clientName: payload.clientName || "",
        postType,
      })
    );
    sessionStorage.setItem("layoutPostType", postType);
  } catch (e) {
    console.error(e);
  }

  const page = postType === "video" ? "/videoInput.html" : "/stillinputform.html";
  window.location.assign(`${page}?from=dashboard&postType=${encodeURIComponent(postType)}`);
}

export function openStillInputFormForBrand(brandListItem) {
  openLayoutInputFormForBrand(brandListItem, "still");
}

export function openVideoInputFormForBrand(brandListItem) {
  openLayoutInputFormForBrand(brandListItem, "video");
}
